function AIPoweredIcon({
  size = 12,
  className = "fill-[#722ED1]",
  opacity = "1"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.5 5.5C3.26142 5.5 5.5 3.26142 5.5 0.5H6.5C6.5 3.26142 8.7386 5.5 11.5 5.5V6.5C8.7386 6.5 6.5 8.7386 6.5 11.5H5.5C5.5 8.7386 3.26142 6.5 0.5 6.5V5.5ZM2.90171 6C4.28447 6.60465 5.39535 7.7155 6 9.0983C6.60465 7.7155 7.7155 6.60465 9.0983 6C7.7155 5.39535 6.60465 4.28447 6 2.90171C5.39535 4.28447 4.28447 5.39535 2.90171 6Z"
        fill="current"
        fillOpacity={opacity}
      />
    </svg>
  );
}

export default AIPoweredIcon;
